<template>
  <b-row>
    <b-col cols="6" offset="3" class="mb-4">
      <label>Réunion Name</label>
      <ValidationProvider
        ref="vee-meeting-name"
        v-slot="{ errors, classes }"
        :name="'réunion'"
        rules="required"
      >
        <b-input :value="meeting.name" @input="updateMeeting('name', $event)"></b-input>
        <span :class="classes">{{ errors[0] }}</span>
      </ValidationProvider>
    </b-col>
    <b-col cols="6" offset="3">
      <label>Préciser la copropriété concernée</label>
      <ValidationProvider
        ref="vee-meeting-building_id"
        v-slot="{ errors, classes }"
        :name="'copropriété concernée'"
        rules="required"
      >
        <v-select
          :value="meeting.building_id"
          class="w-100"
          :reduce="name => name.id"
          :options="buildingsOptions"
          label="name"
          @input="updateMeeting('building_id', $event)"
        >
          <span slot="no-options">
            {{ $t("general.select_no_option") }}
          </span>
        </v-select>
        <span :class="classes">{{ errors[0] }}</span>
      </ValidationProvider>
    </b-col>
  </b-row>
</template>
<script>
export default {
  props: {
    meeting: {
      type: Object,
      require: true,
    },
    buildingsOptions: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  methods: {
    updateMeeting(key, value) {
      this.$emit("updateMeeting", key, value);
    },
  },
};
</script>
